import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { request } from '../api/client';

type VerifyState = 'loading' | 'success' | 'error';

export function VerifyPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [state, setState] = useState<VerifyState>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setState('error');
      setMessage('缺少验证链接参数');
      return;
    }

    let cancelled = false;
    async function verify() {
      try {
        await request<{ ok: boolean }>(`/auth/verify?token=${token}`);
        if (!cancelled) {
          setState('success');
          setMessage('邮箱验证成功！');
        }
      } catch (err) {
        if (!cancelled) {
          setState('error');
          setMessage(err instanceof Error ? err.message : '验证链接已失效或已过期');
        }
      }
    }
    verify();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-subtle px-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-bg-surface p-8 text-center shadow-sm">
        {state === 'loading' && (
          <>
            <Loader2 className="mx-auto h-12 w-12 animate-spin text-accent" />
            <h1 className="mt-4 text-xl font-semibold">验证中…</h1>
            <p className="mt-2 text-sm text-text-secondary">正在验证您的邮箱，请稍候</p>
          </>
        )}
        {state === 'success' && (
          <>
            <CheckCircle className="mx-auto h-12 w-12 text-[#22c55e]" />
            <h1 className="mt-4 text-xl font-semibold">验证成功</h1>
            <p className="mt-2 text-sm text-text-secondary">{message}</p>
            <Link to="/login" className="btn btn-primary btn-md mt-6 inline-flex">
              去登录
            </Link>
          </>
        )}
        {state === 'error' && (
          <>
            <XCircle className="mx-auto h-12 w-12 text-danger" />
            <h1 className="mt-4 text-xl font-semibold">验证失败</h1>
            <p className="mt-2 text-sm text-text-secondary">{message}</p>
            <Link to="/login" className="btn btn-secondary btn-md mt-6 inline-flex">
              返回登录
            </Link>
          </>
        )}
      </div>
    </div>
  );
}